import BScroll from "@better-scroll/core";
import ObserveDOM from "@better-scroll/observe-dom";
import Pullup from "@better-scroll/pull-up";
import { onMounted, onUnmounted, ref } from "vue";

BScroll.use(ObserveDOM);
BScroll.use(Pullup);

const useScroll = (wrapperRef, options, emit) => {
  const scroll = ref(null);

  onMounted(() => {
    scroll.value = new BScroll(wrapperRef.value, {
      observeDOM: true,
      ...options
    });

    if (options.probeType > 0) {
      scroll.value.on("scroll", pos => {
        emit("scroll", pos);
      });
    }

    if (options.pullUpLoad) {
      scroll.value.on("pullingUp", () => {
        emit("isPullingUp");
      });
    }
  });

  onUnmounted(() => {
    scroll.value.destroy();
  });

  return scroll;
};

export default useScroll;
